export default __webpack_public_path__ + "images/er-458bc299993e856c309df58a7fb0c4ea.svg";